import * as THREE from "three";
import { FikoGrup } from "./FikoGrup";
import { FikoKonumlar } from "./FikoKonumlar/FikoKonumlar";
import { FikoSahne } from "./FikoSahne";
import { jsondan } from "../FikoThreeType";
import { FikoEksen } from "./FikoEksen";
import { FikoGrupCizim } from "./FikoGrupCizim";
import { FikoIsikOrtam } from "./FikoIsikOrtam";

export class FikoUrunAgaci extends FikoGrup {
    override type: any = "FikoUrunAgaci";
    /** */
    sayac = 1;
    /** */
    anaEksen: FikoEksen = new FikoEksen(this.sahne, "Ana Eksen");
    isiklar: FikoGrup = new FikoGrup(this.sahne, "Işıklar")

    sagMenu = [
        {
            simge: null,
            baslik: "Ekrana Sığdır",
            tiklandi: () => {
                this.sahne.ekranaSigdir(this.sahne);
            }
        },
    ]

    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/logo.webp";

        this.anaEksen.visible = false;
        this.ekle(this.anaEksen);

        // this.ekle(new FikoGrupCizim(this.sahne, "Fiko Grup"));
        // this.anaEksen.hazirla(this.sahne);
        /** */

        /** */

        // let light = new FikoIsikOrtam(this.sahne, "Ana Ortam Işığı");
        // this.add(light);
        // this.isiklar.ekle(light)

        // this.ekle(this.isiklar);

        // this.sahne.anaGosterim.aktifKontrol.addEventListener("change", (event: any) => {
        //     light.position.copy(sahne.anaGosterim.aktifKamera.position);
        //     light.matrix.copy(sahne.anaGosterim.aktifKamera.matrix);
        //     sahne.anaGosterim.ciz()
        // });


        // this.ekle(this.isiklar)
    }


    // fromJson(json?: any) {
    //     this.anaEksen.fromJson(json.anaEksen)
    // }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } // super.toJSON(meta);

        _rslt.anaEksen = this.anaEksen.toJSON();

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new FikoUrunAgaci(sahne, json.isim);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        _rslt.anaEksen = jsondan(sahne, parent, json.konumlar);


        return _rslt;

    }
}